import ExcelJS from "exceljs";
import fileDownload from "js-file-download";

import { budgetLineItemLabel } from "./budgetLineItems.js";

const MONEY = "$#,##0.00";
const EXPORT_COLUMNS = [
  { header: "Budget", field: "budget_name" },
  { header: "Status", field: "budget_status" },
  { header: "County", field: "countyLabel" },
  { header: "Crop", field: "commodity_name" },
  { header: "Type", field: "type_name" },
  { header: "Practice", field: "practice_name" },
  { header: "Acres", field: "reported_acreage", numFmt: "#,##0.00" },
  { header: "Cost/ac", field: "costPerAcre", numFmt: MONEY },
];
const COST_EXPORT_COLUMNS = [
  { header: "Budget", field: "budget_name" },
  { header: "County", field: "countyLabel" },
  { header: "Crop", field: "cropLabel" },
  { header: "Cost", field: "costLabel" },
  { header: "Acres", field: "reported_acreage", numFmt: "#,##0.00" },
  { header: "$/acre", field: "costValue", numFmt: MONEY },
  { header: "$ total", field: "costTotal", numFmt: MONEY },
];

/**
 * Budget Master rows as shown (filtered and sorted), one row per county practice; with a cost, the Costs screen's
 * rows for that cost. No totals: budgets are scenarios.
 */
export async function exportBudgetMasterWorkbook({ rows, year, budgets, counties, crops, cost }) {
  if (!rows?.length) {
    throw new Error("No rows to export.");
  }

  const columns = cost ? COST_EXPORT_COLUMNS : EXPORT_COLUMNS;
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Tilley";
  const sheet = workbook.addWorksheet(cost ? "Costs" : "Budget Master");

  sheet.addRow(["Year", year]);
  sheet.addRow(["Budget", budgets.join("; ") || "All"]);
  sheet.addRow(["County", counties.join("; ") || "All"]);
  sheet.addRow(["Crop", crops.join("; ") || "All"]);
  if (cost) sheet.addRow(["Cost", `${budgetLineItemLabel(cost.name)} (${cost.category})`]);
  sheet.addRow([]);

  const headerRow = sheet.addRow(columns.map((col) => col.header));
  headerRow.font = { bold: true };

  rows.forEach((row) => {
    const dataRow = sheet.addRow(columns.map((col) => row[col.field] ?? ""));
    columns.forEach((col, index) => {
      if (col.numFmt) dataRow.getCell(index + 1).numFmt = col.numFmt;
    });
  });

  sheet.columns.forEach((column, index) => {
    let maxLength = columns[index]?.header.length ?? 0;
    column.eachCell({ includeEmpty: false }, (cell) => {
      maxLength = Math.max(maxLength, String(cell.value ?? "").length);
    });
    column.width = Math.min(Math.max(maxLength + 2, 10), 48);
  });

  sheet.views = [{ state: "frozen", ySplit: headerRow.number }];

  fileDownload(
    await workbook.xlsx.writeBuffer(),
    cost ? `Budget-Costs-${cost.name}-${year}.xlsx` : `Budget-Master-${year}.xlsx`
  );
}
